export default {
  amount: "Amount",
  successPendingVerification: "Payment Pending Verification",
  successHeading: "Payment Successful",
  transaction: "Transaction",
  invoice: "Invoice",
  transactionTime: "Transaction Time",
  cannotFetchPaymentTransaction:
    "We ran into an issue fetching your payment transaction. Please try again later.",
};
